import {Action} from '@ngrx/store';
import {Deserialize, Serialize} from 'cerialize';
import { DeleteAnnouncementsAction } from '../actions/announcements/delete-announcements-action';
import { DeleteAnnouncementsErrorAction } from '../actions/announcements/delete-announcements-error-action';
import { GetAnnouncementsAction } from '../actions/announcements/get-announcements-action';
import { GetAnnouncementsErrorAction } from '../actions/announcements/get-announcements-error-action';
import { GetAnnouncementsSuccessAction } from '../actions/announcements/get-announcements-success-action';
import { AnnouncementsState } from '../states/announcements-state';

const initialState = new AnnouncementsState();

export function AnnouncementsReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: AnnouncementsState = Deserialize(serializedState, AnnouncementsState);

  switch (action.type) {
    case GetAnnouncementsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetAnnouncementsSuccessAction.type:
      state.ready = true;
      state.announcements = (<GetAnnouncementsSuccessAction>action).announcements;
      state.error = null;
      break;

    case GetAnnouncementsErrorAction.type:
      state.ready = true;
      state.error = (<GetAnnouncementsErrorAction>action).error;
      break;

    case DeleteAnnouncementsAction.type:
      state.ready = false;
      state.error = null;
      break;

    case DeleteAnnouncementsErrorAction.type:
      state.ready = true;
      state.error = (<DeleteAnnouncementsErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
